import { useSelector } from 'react-redux';

import { Modals } from '@/constants';
import { AnalyticsService, EVENT_CONSTANTS } from '@/services';
import {
  playerThunks,
  selectActiveModalParams,
  selectIsPlaybackRejected,
  selectPlaybackRejectedChapter,
  selectUserCompliance,
  uiActions,
  useAppDispatch,
  useClaimEpisodeMutation,
  useFetchEpisodeQuery,
  useFetchPlanQuery,
} from '@/store';
import { SnackbarUtils } from '@/utils';

import { RedeemModalContent as RedeemModalContentComponent } from './RedeemModalContent.component';

export const RedeemModalContent = () => {
  const dispatch = useAppDispatch();

  const { episodeId } = useSelector(selectActiveModalParams) || {};
  const compliance = useSelector(selectUserCompliance);

  const isPlaybackRejected = useSelector(selectIsPlaybackRejected);
  const playbackRejectedChapter = useSelector(selectPlaybackRejectedChapter);

  const [claimEpisode, claimEpisodeResult] = useClaimEpisodeMutation();

  const { data: plan } = useFetchPlanQuery();
  const { data: episode } = useFetchEpisodeQuery(
    { episodeId, compliance },
    { skip: !episodeId, refetchOnMountOrArgChange: true },
  );

  const onRedeemEpisode = async () => {
    try {
      await claimEpisode({ episodeId }).unwrap();
      AnalyticsService.episodeRedeem({ episodeId });
      if (
        isPlaybackRejected &&
        playbackRejectedChapter &&
        playbackRejectedChapter.episodeId === episodeId
      ) {
        dispatch(
          playerThunks.changeActiveChapter({
            activeChapter: playbackRejectedChapter,
            location: {
              component: EVENT_CONSTANTS.COMPONENT.MODAL,
              modalName: Modals.REDEEM,
              details: EVENT_CONSTANTS.AUTO_PLAY,
            },
          }),
        );
      }
    } catch {
      SnackbarUtils.error('Failed to redeem episode');
    }
  };

  const closeModal = () => dispatch(uiActions.closeActiveModal());

  return (
    <RedeemModalContentComponent
      episode={episode}
      plan={plan}
      claimEpisodeResult={claimEpisodeResult}
      onRedeemEpisode={onRedeemEpisode}
      closeModal={closeModal}
    />
  );
};
